"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoutConfirmDialog = void 0;
var _jsxRuntime = require("react/jsx-runtime");
/** @deprecated LogoutConfirmDialog was moved to @ori-appshell/layouts, this will be removed in the next major release */
const LogoutConfirmDialog = props => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {});
exports.LogoutConfirmDialog = LogoutConfirmDialog;
